import { useState } from 'react';
import { Block, Button, Page } from 'konsta/react';
import { t, type Language } from '@harmony/shared';
import { api, type Me } from '../api';
import { haptic } from '../telegram';
import { LogoMark } from '../components/Logo';

/** First screen: English or Amharic. Shown once; the choice is shared with the bot. */
export function LanguageScreen({ onChosen }: { onChosen: (me: Me) => void }) {
  const [busy, setBusy] = useState<Language | null>(null);

  const choose = async (lang: Language) => {
    haptic('select');
    setBusy(lang);
    try {
      onChosen(await api.setLanguage(lang));
    } finally {
      setBusy(null);
    }
  };

  return (
    <Page className="flex flex-col justify-center">
      <div className="mb-8 text-center">
        <div className="mb-3 flex justify-center">
          <LogoMark size={88} />
        </div>
        <h1 className="text-2xl font-bold tracking-tight">harmony · ሃርመኒ</h1>
        <p className="mt-2 text-tg-hint">
          {t('en', 'app.choose_language')} / {t('am', 'app.choose_language')}
        </p>
      </div>
      <Block className="space-y-3">
        <Button large rounded disabled={!!busy} onClick={() => choose('en')}>
          {t('en', 'lang.en')}
        </Button>
        <Button large rounded outline disabled={!!busy} onClick={() => choose('am')}>
          {t('am', 'lang.am')}
        </Button>
      </Block>
    </Page>
  );
}
